import React from 'react';
import { Hero } from './components/Hero';
import { Stats } from './components/Stats';
import { BeforeAfter } from './components/BeforeAfter';
import { PainPoints } from './components/PainPoints';
import { Tomos } from './components/Tomos';
import { Bonos } from './components/Bonos';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { About } from './components/About';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="w-full overflow-x-hidden bg-cream font-sans text-navy-900" data-id="element-0" data-mp="2wiyxuugtfxcq">
      <main className="w-full" data-id="element-1" data-mp="28tw5osok2m3z">
        <Hero data-id="element-2" data-mp="28t4ju9krg2qw" />
        <Stats data-id="element-3" data-mp="28sl48zil1qg1" />
        <BeforeAfter data-id="element-4" data-mp="28s2y9b64bxux" />
        <PainPoints data-id="element-5" data-mp="23vkuoemiy5k6" />
        <Tomos data-id="element-6" data-mp="23w4clvc6cty7" />
        <Bonos data-id="element-7" data-mp="23ujlkfp2jt53" />
        <Offer data-id="element-8" data-mp="23v2sz2h3ez4v" />
        <Guarantee data-id="element-9" data-mp="23ti864kkyuk7" />
        <Testimonials data-id="element-10" data-mp="3ik7fce9tu7pl" />
        <About data-id="element-11" data-mp="3ikqwhsrnks2k" />
        <FAQ data-id="element-12" data-mp="3ij65gd4jrr9g" />
        <FinalCTA data-id="element-13" data-mp="3ijpc2xoqyt86" />
      </main>

      <footer className="w-full bg-navy-900 px-4 pb-28 pt-8 text-center sm:pb-32" data-id="element-14" data-mp="3mlj8uuvtnd32">
        <p className="text-[12.5px] font-bold uppercase tracking-[0.22em] text-white" data-id="element-15" data-mp="3mj6hjr46bqdc">
          Dra. Karito · Ruta Clínica GLP-1™
        </p>
        <p className="mx-auto mt-3 max-w-md text-[11.5px] leading-relaxed text-navy-200" data-id="element-16" data-mp="6801qozk67w">
          Material educativo dirigido a profesionales de la salud. No sustituye
          el juicio clínico individual ni las recomendaciones de las agencias
          reguladoras de cada país.
        </p>
        <p className="mt-4 text-[11px] text-navy-400" data-id="element-17" data-mp="38li8dgjgy7o4">
          © {new Date().getFullYear()} Dra. Karito. Todos los derechos
          reservados.
        </p>
      </footer>

      <PurchasePopup data-id="element-18" data-mp="nvj1lae5u4n3" />
      <FloatingCTA data-id="element-19" data-mp="nwc2vvuco1xu" />
    </div>;
}